<template>
  <div>
    <header class="page-heading"></header>
    <tabs @changeTabs="changeTabs" class="ut-mb-10">

      <!-- Prospects -->
      <tab
        name="Prospects"
        :iconName="'IconProspects'"
        :selected="true"
        :newCount="totalCount"
        :gacategory="gacategory"
        :gaaction="'Secondary tab menu'"
        :galabel="'Prospects'">
        <div class="sm:ut-mx-0 md:ut--mx-8">
          <prospecting-dashboard/>
        </div>
      </tab>

      <!-- Assistant -->
      <tab v-if="userProspectorStatus.prospectingStatus.hasOAAssitant"
        name="Assistant"
        :iconName="'IconAssistant'"
        :gacategory="gacategory"
        :gaaction="'Secondary tab menu'"
        :galabel="'Assistant'"
        >
        <div v-if="agentCallActivities.loaded" class="ut-relative sm:ut-mx-0">

          <div v-if="totalConversations <= 15"
                 class="ut-text-center ut-mt-12">
              <svg-icon
                  :icon="'LoadingAssistant'"
                  :size="86"
                  :addClass="'ut-text-neutral-080'"></svg-icon>
              <h2 class="ut-text-xl ut-text-neutral-200 ut-font-bold ut-mt-4 ut-mb-2">
                Almost there</h2>
              <p class="ut-text-base ut-m-auto ut-w-1/3 ut-text-neutral-200">We're still setting up your Assistant. Once they've made their first few calls the data will appear here.</p>
            </div>

          <div v-else>
            <prospecting-assistant :activities="agentCallActivities.data"
              />

          </div>
        </div>
        <loading-spinner v-else />
      </tab>

      <!-- Database builder -->
      <tab
        name="Database Builder"
        :iconName="'IconDBBuilder'"
        :gacategory="gacategory"
        :gaaction="'Secondary tab menu'"
        :galabel="'Database Builder'">
        <div v-if="agentPliteActivities.loaded" class="ut-relative sm:ut-mx-0">

          <div v-if="!agentPliteActivities.data"
                 class="ut-text-center ut-mt-12">
              <svg-icon
                  :icon="'LoadingDBBuilder'"
                  :size="106"
                  :addClass="'ut-text-neutral-080'"></svg-icon>
              <h2 class="ut-text-xl ut-text-neutral-200 ut-font-bold ut-mt-4 ut-mb-2">
                Almost there</h2>
              <p class="ut-text-base ut-m-auto ut-w-1/3 ut-text-neutral-200">We’re working on something,<br>Check back soon to see the results.</p>
            </div>

          <div v-else>
            <prospecting-dbbuilder :activities="agentPliteActivities.data"
              />

          </div>
        </div>
        <loading-spinner v-else />
      </tab>

    </tabs>

  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import SvgIcon from '@/components/SvgIcon.vue';
import Tab from '@/components/Forms/Tab.vue';
import Tabs from '@/components/Forms/Tabs.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';
import ProspectingDashboard from '@/components/Prospecting/ProspectingDashboard/ProspectingDashboard.vue';
import ProspectingAssistant from '@/components/Prospecting/ProspectingDashboard/ProspectingAssistant.vue';
import ProspectingDbbuilder from '@/components/Prospecting/ProspectingDashboard/ProspectingDbbuilder.vue';
import { ProspectActivityMediumTypeId } from '@/Mapper/ProspectActivityMediumType';
import { ProspectActivityActionTypeId } from '@/Mapper/ProspectActivityActionType';

export default {
  name: 'ProspectingDashboardSummary',
  components: {
    Tabs,
    Tab,
    SvgIcon,
    LoadingSpinner,
    ProspectingDashboard,
    ProspectingAssistant,
    ProspectingDbbuilder,
    ProspectActivityMediumTypeId,
    ProspectActivityActionTypeId,
  },
  props: {
    gacategory: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
      agent: state => state.agentStore.agent,
      prospectStats: state => state.prospectsStore.prospectStats,
      userProspectorStatus: state => state.userStore.userProspectorStatus,
      agentCallActivities: state => state.prospectsStore.agentCallActivities,
      agentPliteActivities: state => state.prospectsStore.agentPliteActivities,
    }),
    totalCount() {
      return this.prospectStats? this.prospectStats.newProspectsCount
        + this.prospectStats.attemptedProspectsForAttentionCount
        + this.prospectStats.prospectsToFollowUpForAttentionCount
        + this.prospectStats.prospectsBookedAppraisalForAttentionCount : 0;
    },
    totalConversations() {
      const results = this.agentCallActivities.data.Activities.filter(a => 
        [ProspectActivityActionTypeId.CallContact, ProspectActivityActionTypeId.CallSuccess].indexOf(a.actionType.activityActionTypeId) > -1); 
        return results.length;
    },
  },
  mounted() {},
  watch: {},
  created() {
    if (!this.prospectStats) {
      const payload = {
        agentId: this.agent.id,
      };

      this.loadProspectsStats(payload);
    }
  },
  methods: {
    ...mapActions('prospectsStore', [
      'loadAgentCallActivities',
      'loadAgentPliteActivities',
      'loadProspectsStats'
    ]),
    changeTabs(activeTab) {
      if (activeTab === 'Assistant' && !this.agentCallActivities.loaded) {
        console.log(activeTab);
        const payload = {
          agentId: this.agent.id,
          activityMediumTypeId: ProspectActivityMediumTypeId.OA_Assistant,
        };
        this.loadAgentCallActivities(payload);
      } else if ( activeTab === 'Database Builder' && !this.agentPliteActivities.loaded) {
        console.log(activeTab);

        const payload = {
          agentId: this.agent.id,
          activityMediumTypeId: ProspectActivityMediumTypeId.Plite,
        };
        this.loadAgentPliteActivities(payload).then((data) => {
          console.log(this.agentPliteActivities.data);
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .fallback-text {
    @apply ut-max-w-full ut-text-center ut-m-auto;
    width: 500px;
  }

  .prospect-filter {
    @apply ut-w-full ut-mb-4;

    @screen md {
      width: auto;
      position: absolute;
      right: 0;
      // top: -52px;
    }

    @screen md {
      top: -76px;
    }
  }
</style>
